import { createSlice } from '@reduxjs/toolkit'
import i18n from '../../translations/strings';

export const EventStatusPayment = [
  {
    id: 'PAID',
    name: i18n.t('eventsList.paid'),
  },
  {
    id: 'NOT_YET_PAID',
    name: i18n.t('eventsList.notPaid'),
  }
]


export enum ReservationBookingActionType {
  CheckIn = 'check-in',
  CheckOut = 'check-out',
}
const initialState = {
  loading: false,
  reservation: null,
  confirmReservationSuccess: false,
  cancelReservationSuccess: false,
  checkInOutEventSuccess: null,
  addAdminNoteSuccess: false,
  updatePaymentStatusSuccess: false,
  errorPaymentStatus: false,
  rooms: null,
  error: null,
  errorConfirmCheckInOutReservation: null
}

const slice = createSlice({
  name: 'handleReservation',
  initialState: initialState,
  reducers: {
    handleReservationAction: (state, action) => {
      state.loading = true
      state.error = null
      state.confirmReservationSuccess = false
      state.addAdminNoteSuccess = false
      state.checkInOutEventSuccess = null
      state.errorConfirmCheckInOutReservation = null
      state.cancelReservationSuccess = false
      state.updatePaymentStatusSuccess = false
    },
    setReservationAction:(state, action)=>{
      state.loading = false
      state.reservation = action.payload.reservation
      state.rooms = action.payload.rooms
      state.error = null
    },
    confirmReservationAction: (state, action) => {
      state.loading = true
      state.error = null
      state.confirmReservationSuccess = false
    },
    setConfirmReservationSuccessAction: (state) => {
      state.loading = false
      state.error = null
      state.confirmReservationSuccess = true
    },
    addAdminNoteAction: (state, action) => {
      state.loading = true
      state.error = null
      state.addAdminNoteSuccess = false
    },
    setAddAdminNoteSuccessAction: (state) => {
      state.loading = false
      state.error = null
      state.addAdminNoteSuccess = true
    },
    deleteReservationFromAdminAction: (state, action) => {
      state.loading = true
      state.error = null
    },
    deleteReservationFromAdminSuccessAction: (state) => {
      state.loading = false
      state.error = null
      state.cancelReservationSuccess = true
    },
    checkInOutEventReservationAction: (state, action) => {
      state.loading = true
      state.error = null
      state.confirmReservationSuccess = false
    },
    checkInOutEventReservationSuccessAction: (state, action) => {
      state.loading = false
      state.error = null
      state.checkInOutEventSuccess = action.payload
      state.errorConfirmCheckInOutReservation = null
    },
    handleReservationErrorAction: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
    setErrorConfirmCheckInOutReservationAction: (state, action) => {
      state.loading = false
      state.error = null
      state.errorConfirmCheckInOutReservation = action.payload
    },
    updateIntervalPaymentStatusAction:(state, action)=> {
      state.loading = true
      state.error = null
    },
    updateIntervalPaymentStatusSuccessAction:(state)=> {
      state.loading = false
      state.error = null
      state.updatePaymentStatusSuccess = true
    },
    setErrorUpdateIntervalPaymentStatusAction:(state, action)=> {
      state.loading = false
      state.errorPaymentStatus = action.payload
      state.updatePaymentStatusSuccess = false
    },
    handleReservationPartialResetState: (state) => {
      state.loading = false
      state.error = null
      state.errorConfirmCheckInOutReservation = null
      state.confirmReservationSuccess = false
      state.checkInOutEventSuccess = null
      state.updatePaymentStatusSuccess = false
    },
    handleReservationResetState: () => initialState,
  },
});

export const {
  handleReservationAction,
  setReservationAction,
  handleReservationErrorAction,
  confirmReservationAction,
  setConfirmReservationSuccessAction,
  addAdminNoteAction,
  setAddAdminNoteSuccessAction,
  deleteReservationFromAdminAction,
  deleteReservationFromAdminSuccessAction,
  checkInOutEventReservationAction,
  checkInOutEventReservationSuccessAction,
  setErrorConfirmCheckInOutReservationAction,
  handleReservationPartialResetState,
  handleReservationResetState,
  updateIntervalPaymentStatusAction,
  updateIntervalPaymentStatusSuccessAction,
  setErrorUpdateIntervalPaymentStatusAction
} = slice.actions

export default slice.reducer
